/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

export {stripExpressionComments, stripExpressionMarkers} from './lib/utils.js';
